import { Link } from 'react-router-dom';
import Logo from '~/components/Logo';
import s from './Footer.module.scss';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={s.footer}>
      <div className={s.inner}>
        <div className={s.brandCol}>
          <Logo />
          <p>The metadata API for video apps.</p>
        </div>

        <nav className={s.cols}>
          <Link to="/docs">Documentation</Link>
          <Link to="/docs/api">API Reference</Link>
          <Link to="/pricing">Pricing</Link>
          {/* /terms and /privacy are server-rendered — full navigation on purpose */}
          <a href="/terms">Terms of Service</a>
          <a href="/privacy">Privacy Policy</a>
        </nav>
      </div>

      <div className={s.bottom}>© {year} MetaHub. All rights reserved.</div>
    </footer>
  );
}
